import { useEffect } from 'react';
import { useSEO } from '@/hooks/useSEO';

const SEOHead = () => {
  const { seoConfig, loading } = useSEO();

  useEffect(() => {
    if (loading || !seoConfig) return;

    // Update document title
    if (seoConfig.title) {
      document.title = seoConfig.title;
    }

    // Helper function to update or create meta tags
    const updateMetaTag = (name: string, content: string, property?: boolean) => {
      if (!content) return;
      
      const attribute = property ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };

    // Update basic meta tags
    if (seoConfig.description) {
      updateMetaTag('description', seoConfig.description);
    }
    
    if (seoConfig.keywords) {
      updateMetaTag('keywords', seoConfig.keywords);
    }
    
    if (seoConfig.author) {
      updateMetaTag('author', seoConfig.author);
    }

    // Update Open Graph tags
    if (seoConfig.og_title) {
      updateMetaTag('og:title', seoConfig.og_title, true);
    }
    
    if (seoConfig.og_description) {
      updateMetaTag('og:description', seoConfig.og_description, true);
    }
    
    if (seoConfig.og_image) {
      updateMetaTag('og:image', seoConfig.og_image, true);
    }
    
    if (seoConfig.og_image_alt) {
      updateMetaTag('og:image:alt', seoConfig.og_image_alt, true);
    }
    
    if (seoConfig.og_type) {
      updateMetaTag('og:type', seoConfig.og_type, true);
    }
    
    if (seoConfig.og_url) {
      updateMetaTag('og:url', seoConfig.og_url, true);
    }
    
    if (seoConfig.og_site_name) {
      updateMetaTag('og:site_name', seoConfig.og_site_name, true);
    }

    // Update canonical URL
    if (seoConfig.canonical_url) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', seoConfig.canonical_url);
    }

  }, [seoConfig, loading]);

  return null;
};

export default SEOHead;